import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-light',
  templateUrl: './app-light.component.html',
  styleUrls: ['./app-light.component.scss']
})
export class AppLightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
